// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/ExpenseClaimKpiBar.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claim KPI Bar
// ======================================================================

import React from "react";

export default function ExpenseClaimKpiBar({

  summary = {},

}) {

  const cards = [

    {
      title: "Total Claims",
      value:
        summary.total_claims || 0,
      color: "#0d6efd",
      icon: "fas fa-file-invoice-dollar",
    },

    {
      title: "Draft",
      value:
        summary.draft_claims || 0,
      color: "#6c757d",
      icon: "fas fa-edit",
    },

    {
      title: "Pending Approval",
      value:
        summary.pending_claims || 0,
      color: "#fd7e14",
      icon: "fas fa-user-clock",
    },

    {
      title: "Approved",
      value:
        summary.approved_claims || 0,
      color: "#198754",
      icon: "fas fa-check-circle",
    },

    {
      title: "Rejected",
      value:
        summary.rejected_claims || 0,
      color: "#dc3545",
      icon: "fas fa-times-circle",
    },

    {
      title: "Paid",
      value:
        summary.paid_claims || 0,
      color: "#20c997",
      icon: "fas fa-money-check-alt",
    },

  ];

  return (

    <div className="row mb-4">

      {cards.map((card) => (

        <div
          className="col-xl-2 col-lg-4 col-md-6 mb-3"
          key={card.title}
        >

          <div
            className="card shadow-sm h-100"
            style={{
              borderTop:
                `4px solid ${card.color}`,
              borderRadius: 12,
            }}
          >

            <div
              className="
                card-body
                d-flex
                justify-content-between
                align-items-center
              "
            >

              <div>

                <div
                  className="text-muted small"
                >
                  {card.title}
                </div>

                <h3
                  className="mb-0 fw-bold"
                >
                  {card.value}
                </h3>

              </div>

              <div>

                <i
                  className={card.icon}
                  style={{
                    fontSize: 28,
                    color: card.color,
                  }}
                />

              </div>

            </div>

          </div>

        </div>

      ))}

    </div>

  );

}